import {DevicePlatformType, OnRenderData} from '../types';

export type CommonRenderRequestParts = {
  onClose?: () => void;
  onError?: (data: unknown) => void;
  onRender?: (data: OnRenderData) => void;
};

type FloorAdRenderRequest = {
  blockId: string;
  type: 'floorAd';
  platform: DevicePlatformType;
} & CommonRenderRequestParts;

type BannerRenderRequest = {
  blockId: string;
  renderTo: string;
} & CommonRenderRequestParts;

export type AdvManager = {
  render: (
    props: FloorAdRenderRequest | BannerRenderRequest,
    renderFallback: (() => void) | undefined,
  ) => void;
  getPlatform: () => DevicePlatformType;
  destroy: (params: {blockId: string; renderTo: string}) => void;
};

export const getAdvManager = (): AdvManager =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).Ya.Context.AdvManager;
